import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { Briefcase } from "lucide-react";
import OtpLogin from "@/components/OtpLogin";
import { useOpenDestination } from "@/lib/signIn";
import { TEST_NUMBERS } from "@/lib/testAccounts";

/**
 * /t/<slug>/seller/login. The same sign-in as everywhere else, on this tenant.
 * A number on one of this tenant's seller profiles opens the seller portal. Any
 * other number goes to what it does have here; it never becomes a seller.
 */
export default function SellerLogin() {
  const { slug } = useParams();
  const open = useOpenDestination();

  const onSignedIn = (session) => {
    if (session.destination.role !== "seller") toast.info("This number is not registered as a seller of this business.");
    open(session);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F5F5] admin-body p-4 sm:p-6">
      <div className="w-full max-w-md bg-white border border-neutral-200 p-6 sm:p-8" data-testid="seller-login-card">
        <Briefcase className="h-6 w-6 mb-2" />
        <div className="admin-overline break-anywhere">Seller · {slug}</div>
        <h1 className="admin-heading text-3xl sm:text-4xl font-bold mt-1">Manage your jobs.</h1>
        <p className="text-sm text-neutral-500 mt-2">Sign in with the mobile number your business registered for you.</p>
        <div className="mt-8">
          <OtpLogin key={slug} slug={slug} prefer="seller" look="console" testid="seller-login" onSignedIn={onSignedIn} testNumbers={TEST_NUMBERS} />
        </div>
      </div>
    </div>
  );
}
